export const dispatch = async () => null

export default dispatch
